/* @flow */

import React, { Component } from 'react';
import { Item } from 'semantic-ui-react';
import RichTextItem from 'shared/components/RichTextItem';
import { EditorState } from 'draft-js';
import { htmlToState, linkDecorator, stateToHTML } from 'utils/richtext';

type Props = {
  block: EditorialTextBlock,
  onSerialize?: (block: EditorialTextBlock) => void,
  onCanSubmitChanged?: (value: boolean) => void,
};

type State = {
  editor?: Object,
};

const mapBlockContentToEditorState = block =>
  block.content
    ? htmlToState(block.content)
    : EditorState.createEmpty(linkDecorator);

class Edit extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      editor: mapBlockContentToEditorState(props.block),
    };
  }

  serializeAsHtml = editorState => {
    const { block, onSerialize, onCanSubmitChanged } = this.props;

    this.setState({
      editor: editorState,
    });

    onSerialize({
      ...block,
      content: stateToHTML(editorState.getCurrentContent()),
    });
    onCanSubmitChanged(true);
  };

  render() {
    const { editor } = this.state;

    return (
      <Item.Content>
        <RichTextItem
          parentState={editor}
          onChange={this.serializeAsHtml}
          withTextBlocks
          withInlineBasics
          withLinks
          withColors
        />
      </Item.Content>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/text/Edit.js